module.exports = __webpack_public_path__ + "img/clayton-seal-logo.a3e05814.jpg";